import Button from 'components/Button/Button'
import { Input } from 'components/Input'
import Modal from 'components/Modal'
import React, { useState } from 'react'
import { Col, Row } from 'react-grid-system'
import { ResetPasswordProps } from './ResetPassword.props'
import { ResetPasswordContainer } from './ResetPassword.styled'

const ResetPassword: React.FC<ResetPasswordProps> = ({ onClose }) => {
  const [oldPassword, setOldPassword] = useState<string>('')
  const [newPassword, setNewPassword] = useState<string>('')
  const [confirmPassword, setConfirmPassword] = useState<string>('')
  return (
    <Modal
      showClose
      onClose={onClose}
      title="Reset Password"
      containerStyle={{ minHeight: 400 }}>
      <ResetPasswordContainer>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Input
              fullWidth
              label={'Old password'}
              type="password"
              value={oldPassword}
              onTextChange={psw => setOldPassword(psw)}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Input
              fullWidth
              label={'New password'}
              type="password"
              value={newPassword}
              onTextChange={psw => setNewPassword(psw)}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Input
              fullWidth
              label={'Confirm password'}
              type="password"
              value={confirmPassword}
              onTextChange={psw => setConfirmPassword(psw)}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Button
              text="Update user"
              variant="primary"
              preset="filled"
              size={'medium'}
            />
          </Col>
        </Row>
      </ResetPasswordContainer>
    </Modal>
  )
}

export default ResetPassword
